import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
	Card,
	CardContent,
	makeStyles,
	CardHeader,
	Typography,
	DialogContent,
	Divider,
} from '@material-ui/core';
import { LoadingProps, TaskDetails, TaskResponse } from '../../@types';
import { deleteTask, getTask } from '../../axios/tasks';
import { blue, grey, red } from '@material-ui/core/colors';
import BackBanner from '../../common/Banners/BackBanner';
import { useEffect, useState } from 'react';
import { useCardStyles } from '../../App';
// import { ItemCardHeader } from '../../common/List/ItemCardHeader';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import theme from '../../theme';
import ItemList from '../../common/List/ItemList';
import Box from '@material-ui/core/Box';
import { AccountCircle, AddBox, ArrowForwardIos, Chat, MoreVert } from '@material-ui/icons';
import Popover from '@material-ui/core/Popover';
import DeleteButton from '../../common/Button/DeleteButton';
import UpdateButton from '../../common/Button/UpdateButton';
import Dialog from '@material-ui/core/Dialog';
import UpdateTask from './UpdateTask';
import DeleteItemConfirmation from '../../common/Item/DeleteItemConfirmation';
import ChatRoom from '../ChatRoom/ChatRoom';
import SubmitButton from '../../common/Button/SubmitButton';
import Comments from '../../common/Comments/Comments';
import Grid from '@material-ui/core/Grid';
import CreateTaskResponse from '../Response/CreateResponse';
import { UserCardHeader } from '../../common/List/UserCardHeader';
import CancelButton from '../../common/Button/CancelButton';
import UpdateItemConfirmation from '../../common/Item/UpdateItemConfirmation';
import NoItems from '../../common/List/NoItems';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles((theme) => ({
	root: {},
	media: {
		height: 0,
		paddingTop: '56.25%', // 16:9
	},
	text: {
		fontSize: '15px',
		['@media (max-width:400px)']: {
			fontSize: '5vw',
		},
	},
	editIcon: {
		color: theme.palette.common.white,
	},
	section: {
		margin: '20px 0px 10px',
	},
	members: {
		margin: '20px 0px 0px',
	},
	updateButton: {
		width: '100%',
		marginBottom: '10px',
	},
	deleteButton: {
		width: '100%',
	},
	popupButton: {
		width: '150px',
		padding: '10px',
		backgroundColor: theme.palette.primary.main,
	},
	chat: {
		borderRadius: '10px',
		marginTop: '20px',
		padding: '0px',
		backgroundColor: theme.palette.secondary.dark,
	},
	chatButton: {
		position: 'fixed',
		right: 150,
		bottom: 100,
	},
	gridWrapper: {
		// backgroundColor: 'white'
	},
	createItemButton: {
		height: '30px',
		marginBottom: '10px',
		width: '120px',
		float: 'right',
		// fontSize: '12px'
	},
	userWrapper: {
		padding: '10px',
		margin: '0px 0px 10px',
		backgroundColor: theme.palette.secondary.dark,
		borderRadius: '10px',
		alignItems: 'center',
	},
	userProfile: {
		fontSize: '30px',
        width: '50px',
        transform: 'translateY(4px)',
        display: 'inline',
	},
	userName: {
		fontSize: '30px',
        display: 'inline',
    },
	userDate: {
		color: theme.palette.grey[400],
		float: 'right',
		marginRight: '10px',
	},
	image: {
		width: 'auto',
		display: 'block',
		height: '250px',
		margin: '0px auto',
		textAlign: 'center'
	},
	divider: {
		margin: '50px 0px 30px'
	}
}));

export const TaskDetail = (props: LoadingProps) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	// const id = open ? 'simple-popover' : undefined;
	const [openUpdate, setOpenUpdate] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);
	const [openChat, setOpenChat] = useState(false);

	const [openCreate, setOpenCreate] = useState(false);

	const handleCreateNewItem = () => {
		// history.push(`/investigations/new`);
		setOpenCreate(true);
	};

	const handleCloseCreate = () => {
		props.setLoading(true)
		getTask(taskId).then((res: any) => {
			let date = new Date(res.data.date_created);
			let dateStr = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
			res.data.date_created = dateStr;
			setTask(res.data);
			props.setLoading(false)
		}).catch((err:any)=>{
			console.log(err)
			props.setLoading(false)
		});
		setOpenCreate(false);
	};

	const [openClose, setOpenClose] = React.useState(false);

	const handleViewUser = () => {
        history.push(`/experts/details/${Task.expertId}`)
    }

	const handleOpenForm = () => {
		// history.push(`/tasks/new`);
		handleClose();
		setOpenUpdate(true);
	};

	const handleOpenDelete = () => {
		// history.push(`/tasks/new`);
		handleClose();
		setOpenDelete(true);
	};

	const handleOpenClose = () => {
		// history.push(`/tasks/new`);
		// handleCloseClose();
		setOpenClose(true);
	};

	const handleCloseChat = () => {
		setOpenChat(false);
	};

	const handleCloseUpdate = () => {
		setOpenUpdate(false);
	};

	const handleCloseDelete = () => {
		setOpenDelete(false);
	};

	const handleCloseClose = () => {
		setOpenClose(false);
	};
	const cardStyles = useCardStyles();
	const { taskId } = useParams<any>();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const [Task, setTask] = React.useState<TaskDetails>({
		id: '',
		name: '',
		description: '',
		qId: '',
		expertId: '',
		teamId: '',
		investigationId: '',

		time_estimate: '',
		data: {
			img_url: '',
			q1: '',
			q2: '',
			q3: '',
		},
		request_responses: 1,
		responses: [],
		responseIds: [],

		created_by: '',
		tool: '',
		event_id: '',
		date_created: '',
		isOwner: false,
		status: '',
	});

	React.useEffect(() => {
		if (taskId) {
			props.setLoading(true)
			getTask(taskId).then((res: any) => {
				let date = new Date(res.data.date_created);
				let dateStr = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
				res.data.date_created = dateStr;
				setTask(res.data);
				props.setLoading(false)
			}).catch((err:any) => {
				console.log(err)
				props.setLoading(false)
			});
		}
	}, [taskId]);

	const handleViewResponse = (response: TaskResponse) => {
		history.push(`/responses/details/${response._id}`)
	}

	return (
		<Box className={classes.root}>
			<BackBanner title={'Task Details'} />
			<Card className={cardStyles.card}>
				<Box boxShadow={4}>
					<CardHeader
						className={cardStyles.cardHeader}
						classes={{
							title: cardStyles.headerTitle,
						}}
						action={
							Task.isOwner ? (
								<>
									<IconButton
										onClick={handleClick}
										aria-label='settings'
									>
										<MoreVert
											className={classes.editIcon}
										/>
									</IconButton>
									<Popover
										open={open}
										anchorEl={anchorEl}
										onClose={handleClose}
										anchorOrigin={{
											vertical: 'bottom',
											horizontal: 'center',
										}}
										transformOrigin={{
											vertical: 'top',
											horizontal: 'center',
										}}
									>
										<Box className={classes.popupButton}>
											<UpdateButton
												className={classes.updateButton}
												onClick={handleOpenForm}
												message='Update'
											/>
											<DeleteButton
												onClick={handleOpenDelete}
												className={classes.deleteButton}
												message='Delete'
											/>
										</Box>
									</Popover>
								</>
							) : (
								<></>
							)
						}
						title={`${Task.name}`}
					/>
				</Box>
				<CardContent>
					<img alt='Invalid Image' className={classes.image} src={Task.data.img_url} />
					<Typography variant='h5'>Description:</Typography>
					<Box className={cardStyles.sectionContent}>
						<Typography>
							{Task.description
								? Task.description
								: 'No description'}
						</Typography>
					</Box>
					<Typography variant='h5'>Question 1:</Typography>
					<Box className={cardStyles.sectionContent}>
						<Typography>
							{Task.data.q1}
						</Typography>
					</Box>
					{Task.data.q2 ? 
						<>
							<Typography variant='h5'>Question 2:</Typography>
							<Box className={cardStyles.sectionContent}>
								<Typography>
									{Task.data.q2}
								</Typography>
							</Box>
						</>
						: <></>
					}

					{Task.data.q3 ? 
						<>
							<Typography variant='h5'>Question 3:</Typography>
							<Box className={cardStyles.sectionContent}>
								<Typography>
									{Task.data.q3}
								</Typography>
							</Box>
						</>
						: <></>
					}

					<Grid
						container
						alignItems='flex-end'
						xs={12}
						className={classes.gridWrapper}
					>
						<Grid item xs={8}>
							<Typography
								className={classes.section}
								variant='h5'
							>
								Responses:
							</Typography>
						</Grid>
						<Grid item xs={4}>
							{Task.isOwner ? (
								<>
									<CancelButton
										message={`Close Task`}
										onClick={handleOpenClose}
										className={classes.createItemButton}
									/>
								</>
							) : (
								<SubmitButton
									icon={<AddBox />}
									message={`Respond`}
									onClick={handleCreateNewItem}
									className={classes.createItemButton}
								/>
							)}
							<Dialog
								open={openCreate}
								fullWidth
								// className={classes.form}
								keepMounted
								onClose={handleCloseCreate}
								aria-labelledby='alert-dialog-slide-title'
								aria-describedby='alert-dialog-slide-description'
							>
								<CreateTaskResponse
									onClose={handleCloseCreate}
									task={Task}
								/>
							</Dialog>
						</Grid>
					</Grid>
					<Box className={cardStyles.sectionContent}>
						{Task.responses.length > 0 ? 
							Task.responses.map((response: TaskResponse) => {
							return (
								<Card
									className={cardStyles.card}
									key={'item-' + response._id}
									onClick={() => handleViewResponse(response)}
								>
									<CardHeader
										title={
											<>
												<Typography
													variant='h6'
												>
													{response.created_by}
												</Typography>
											</>
										}
										action={
											<IconButton
												aria-label='chat'
											>
												<ArrowForwardIos />
											</IconButton>
										}
									/>
								</Card>
							);
							})
							: <NoItems name='responses' />
						}
					</Box>

					<Typography variant='h5'>Creator:</Typography>
					<Grid
						container
						xs={12}
						className={`${classes.userWrapper}`}
                        onClick={handleViewUser}
					>
						<Grid item xs={8}>
							<AccountCircle className={classes.userProfile} />
							<Typography
								className={classes.userName}
								variant='h5'
							>
								{Task.created_by}
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								className={classes.userDate}
								variant='subtitle1'
							>
								{Task.date_created}
							</Typography>
						</Grid>
					</Grid>
					
					<Divider className={classes.divider} />

					<Typography className={classes.section} variant='h5'>
						Comments:
					</Typography>
					<Box
						borderRadius='10px'
						bgcolor={theme.palette.secondary.dark}
					>
						<Comments />
					</Box>
				</CardContent>
			</Card>
			<Dialog
				open={openUpdate}
				fullWidth
				keepMounted
				onClose={handleCloseUpdate}
				aria-labelledby='alert-dialog-slide-title'
				aria-describedby='alert-dialog-slide-description'
			>
				<UpdateTask
					handleClose={handleCloseUpdate}
					setTask={setTask}
					task={Task}
				/>
			</Dialog>
			<Dialog
				open={openDelete}
				keepMounted
				onClose={handleCloseDelete}
				aria-labelledby='alert-dialog-slide-title'
				aria-describedby='alert-dialog-slide-description'
			>
				<DeleteItemConfirmation
					id={Task.id}
					confirmationText={Task.name}
					name='task'
					onSubmit={deleteTask}
				/>
			</Dialog>

			<Dialog
				open={openClose}
				keepMounted
				onClose={handleCloseClose}
				aria-labelledby='alert-dialog-slide-title'
				aria-describedby='alert-dialog-slide-description'
			>
				<UpdateItemConfirmation
					id={Task.id}
					confirmationText={Task.name}
					name='task'
					onSubmit={deleteTask}
				/>
			</Dialog>

			<Dialog
				open={openChat}
				keepMounted
				onClose={handleCloseChat}
				aria-labelledby='alert-dialog-slide-title'
				aria-describedby='alert-dialog-slide-description'
			>
				<ChatRoom />
			</Dialog>
		</Box>
	);
};

export default IsLoadingHOC(TaskDetail);
